import AppRoute from "models/AppRoute"

const NotificationsRoute = new AppRoute({
    route: "/notifications",
    navbar: true,
    authRequired: true,
})

export default NotificationsRoute
